import React from 'react';

const HeaderContent = () => {
  return (
    <>
      <article className="block-content block-content-header">
        <div>
          <p className="subheader paragraph-bordered"><span>The ultimate co-op campaign</span></p>
        </div>
        <h1>
          Erin <small>&</small> Luka
        </h1>
        <p className="subheader">
          <strong>
            10 / 10 / 2026
          </strong>
        </p>
      </article>
    </>
  );
};

export default HeaderContent;
